import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { PdfSourceType, PdfSource } from '../constants/pdfConstants';

const usePdfStore = create(
  subscribeWithSelector<{
    detail: any;
    setPdfDetail: (val: any) => void;
    quickoDetail: any;
    setPdfQuickoDetail: (val: any) => void;
    row: any;
    setRow: (val: any) => void;
    pdfSource: PdfSourceType;
    setPdfSource: (val: any) => void;
    quickoGtmSendData: any;
    setQuickoGtmSendData: (val: any) => void;
  }>((set) => ({
    detail: null,
    setPdfDetail: (detail) => set({ detail }),

    quickoDetail: null,
    setPdfQuickoDetail: (data) => set({ quickoDetail: data }),

    row: null,
    setRow: (row) => set({ row }),

    pdfSource: PdfSource.Vehicle,
    setPdfSource: (pdfSource) => set({ pdfSource }),

    quickoGtmSendData: null,
    setQuickoGtmSendData: (data) => set({ quickoGtmSendData: data }),
  }))
);

export default usePdfStore;
